// test1042
(1042 && 0);
